import React from 'react';
import clsx from 'clsx';
import styles from './CenterFill.module.scss';

/**
 * CenterFill
 *
 * A layout utility that:
 * - Expands to full available width
 * - Forces its direct child to fill the width
 * - Centers the child's content horizontally
 *
 * Intended for cases like:
 * - Full-width ghost buttons
 * - Centered call-to-action links
 * - Single-action emphasis layouts
 */
const CenterFill = ({
  as: Component = 'div',
  className,
  children,
  ...rest
}) => {
  return (
    <Component
      className={clsx(styles.CenterFill, className)}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default CenterFill;
